import { Component, ViewEncapsulation, Input, ChangeDetectionStrategy, OnInit, ViewChild } from '@angular/core';
import { NgbModal, ModalDismissReasons, NgbActiveModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
//import { FileUploader } from 'ng2-file-upload/ng2-file-upload';


@Component({
  selector: 'ngbguestpatient',
  templateUrl: './guestpatient.modal.html',
  styleUrls: ['./guestpatient.modal.scss']
})

export class NgbGuestPatientModal implements OnInit {
  
  
  constructor(public activeModal: NgbActiveModal) { }
  ngOnInit() {



  }

  onSubmit() {

  }
  ModalClose() {
    this.activeModal.close();
  }
  
  



}
